export default function setupAxios(axios, { getState }) {
  axios.interceptors.request.use(
    config => {
      const { user } = getState().auth;
      if (user?.access_token) {
        config.headers.Authorization = `Bearer ${user?.access_token}`;
      }
      config.headers.common['Accept'] = 'application/json'
      return config;
    },
    err => Promise.reject(err)
  );
}